import t from '../translate'
import { useFormikContext } from 'formik'
import { SemesterLabel } from './SemesterLabel'
import i18n from '../i18n'



function Edit ({ onClick }) {
  return <button type="button" onClick={onClick} className="edit"></button>
} 



export default function OverviewStep ({
  program,
  locations,
  countries,
  healthInsurances,
  setStep,
}) {
  const { values } = useFormikContext()
  const {
    educationRequired,
    experienceRequired,
    bonusCreditsType,
  } = program?.job ?? {};
  let i = 1

  function countryToName (country) {
    let _country = countries.filter((el) => {
      return el.short === country
    })[0]
    if(!_country) return '';
    if (i18n.language === 'en' && location.titel_en) {
      return _country.name_en
    } else {
      return _country.name_de
    }
  }

  function PersonInformation ({ information }) {
    return <>
      { information.title &&
        <div className="overview-item">
          {t(
            'overview.personal.salutation.label')}: {t(
            'overview.personal.salutation.' + information.title + '.label')}
        </div>  
      }
      
      <div className="overview-item">
        {t(
          'overview.personal.givenName')}: {information.firstName}
      </div>
      <div className="overview-item">
        {t(
          'overview.personal.surName')}: {information.lastName}
      </div>
      <div className="overview-item">
        {t(
          'overview.personal.gender.label')}: {t(
        'overview.personal.gender.' + information.gender)}
      </div>
      {information.birthday &&
      <>
        <div className="overview-item">
          {t(
            'overview.personal.birthday')}: {dateToString(
            information.birthday)}
        </div>
      </>
      }
      <div className="overview-item">
        {t(
          'overview.personal.birthCity')}: {information.birthCity}
      </div>
      <div className="overview-item">
        {t(
          'overview.personal.birthCountry')}: {countryToName(
            information.birthCountry)}
      </div>
    </>
  }

  function getProgramTitle () {
    return program.bezeichnung;
    // if (i18n.language === 'en' && program.title.en) {
    //   return program.title.en
    // } else {
    //   return program.title.de
    // }
  }


  function dateToString (date) {
    const dateArray = date.split('-')
    let dateObject = {
      year: dateArray[0],
      month: dateArray[1],
      day: dateArray[2],
    }

    return `${dateObject.day}.${dateObject.month}.${dateObject.year}`
  }

  return <div className="overview">
    <h3>{t('overview.title')}</h3>
    <div className="overview-section">
      <div className='row'>
        <div className='col-11'>
          <h3>{t('overview.program.title')}</h3>
        </div>
        <div className='col-1 d-flex justify-content-end'>
          <Edit onClick={() => { setStep(0); }}></Edit>
        </div>
      </div>
      {program && values.program && 
        <>
          <div className="overview-item">{t(
            'overview.program.program')}: {getProgramTitle(program)}</div>

          {values.program.price && 
            <div className="overview-item">{t(
              'overview.program.price.label')}: {values.program.price}</div>
          }
          
          <div className="overview-item">{values.program.desiredCourse.text}</div>

          {/* <div className="overview-item">{t(
            'overview.program.desiredCourse.label')}: {values.program.desiredCourse.text}</div> */}
        </>
      }
      { values.program?.course &&
        <>
          <h3>{t('overview.program.courses')}</h3>
          <ul>
          {values.program.course.map((item, index) => (
            item && index in program.courses ? (
              <li key={index}>
                <label>
                  {program.courses[index].name[i18n.language]} ({program.courses[index].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} EUR)
                </label>
              </li>
            ) : null
          ))}
          </ul>
        </>
      }

      {values.program.remark?.text && 
        <div className="overview-item">{t(
          'overview.program.remark.label')}: {values.program.remark.text}</div>
      }
    </div>
    <div className="overview-section">
      {values.data?.personal?.information && (
        <>
          <div className='row'>
            <div className='col-11'>
              <h3>{t('overview.personal.title')}</h3>
            </div>
            <div className='col-1 d-flex justify-content-end'>
              <Edit onClick={() => { setStep(1); }}></Edit>
            </div>
          </div>

          {values.multiple && values.data.personal.information.students && <>
            {values.data.personal.information.company &&
              <div className="overview-item">
                {t(
                  'overview.personal.company')}: {values.data.personal.information.company}
              </div>
            }
            <ul>
              {values.data.personal.information.students.map((student, index) => (
                <li key={index}>
                  <PersonInformation information={student}/>
                </li>
              ))}
            </ul>
          </>
          }
          {!values.multiple && <>
            <PersonInformation information={values.data.personal.information}/>
          </>}
        </>
      )}
    </div>
    <div className="overview-section">
      {values.data?.personal?.address &&
        <>
          <div className='row'>
            <div className='col-11'>
              <h3>{t('overview.address.title')}</h3>
            </div>
            <div className='col-1 d-flex justify-content-end'>
              <Edit onClick={() => { setStep(1); }}></Edit>
            </div>
          </div>
          <div className="overview-item">
            {t(
              'overview.address.streetAndHouseNumber')}: {values.data.personal.address.street} {values.data.personal.address.houseNumber}
          </div>
          <div className="overview-item">
            {t(
              'overview.address.department')}: {values.data.personal.address.department}
          </div>
          <div className="overview-item">
            {t(
              'overview.address.postalCodeAndCity')}: {values.data.personal.address.postalCode} {values.data.personal.address.city}
          </div>
          <div className="overview-item">
            {t(
              'overview.address.country')}: {countryToName(values.data.personal.address.country)}
          </div>
          <div className="overview-item">
            {t(
              'overview.address.email')}: {values.data.personal.address.email}
          </div>
          <div className="overview-item">
            {t(
              'overview.address.phone')}: {values.data.personal.address.phone}
          </div>
        </>
      }
    </div>
    <div className="overview-section">
      {values.data?.payment &&
        <>
          <div className='row'>
            <div className='col-11'>
              <h3>{t('overview.payment.title')}</h3>
            </div>
            <div className='col-1 d-flex justify-content-end'>
              <Edit onClick={() => { setStep(1); }}></Edit>
            </div>
          </div>
          <div className="overview-item">
            {t(
              'overview.payment.type.label')}: {t(
            'overview.payment.type.' + values.data.payment.type)}
          </div>

          {values.data.payment.address?.street && values.data.payment.address?.houseNumber && 
            <div className="overview-item">
              {t(
                'overview.payment.address.streetAndHouseNumber')}: {values.data.payment.address.street} {values.data.payment.address.houseNumber}
            </div>
          }
          {values.data.payment.address?.department && 
            <div className="overview-item">
              {t(
                'overview.payment.address.department')}: {values.data.payment.address.department}
            </div>
          }
          {values.data.payment.address?.postalCode && values.data.payment.address.city && 
            <div className="overview-item">
              {t(
                'overview.payment.address.postalCodeAndCity')}: {values.data.payment.address.postalCode}, {values.data.payment.address.city}
            </div>
          }
          {values.data.payment.address?.country && 
            <div className="overview-item">
              {t(
                'overview.payment.address.country')}: {countryToName(values.data.payment.address.country)}
            </div>
          }
          {values.data.payment.address?.email && 
            <div className="overview-item">
              {t(
                'overview.payment.address.email')}: {values.data.payment.address.email}
            </div>
          }
        </>
      }
    </div>
    {values.data?.studies?.academic &&
      (values.data?.studies?.academic?.bachelor?.has ||
        values.data?.studies?.academic?.diploma?.has ||
        values.data?.studies?.academic?.master?.has ||
        values.data?.studies?.academic?.averageGrade ||
        values.data?.studies?.academic?.city ||
        values.data?.studies?.academic?.date ||
        values.data?.studies?.academic?.country
      ) &&
        <>
          <div className="overview-section">
            <div className='row'>
              <div className='col-11'>
                <h3>{t('overview.academic.title')}</h3>
              </div>
              <div className='col-1 d-flex justify-content-end'>
                <Edit onClick={() => { setStep(1); }}></Edit>
              </div>
            </div>
            {values.data.studies?.academic?.bachelor?.has &&
              <div className="overview-item">
                {t('overview.academic.degree.bachelor')}: {values.data.studies.academic.bachelor.degree || '-'}
              </div>
            }
            {values.data.studies?.academic?.diploma?.has &&
              <div className="overview-item">
                {t('overview.academic.degree.diploma')}: {values.data.studies.academic.diploma.degree || '-'}
              </div>
            }
            {values.data.studies?.academic?.master?.has &&
              <div className="overview-item">
                {t('overview.academic.degree.master')}: {values.data.studies.academic.master.degree || '-'}
              </div>
            }
            {(values.data.studies?.academic?.date || values.data.studies?.academic?.averageGrade) &&
              <div className="overview-item">
                {t('overview.academic.dateAndGrade')}: {dateToString(
                values.data.studies.academic.date) ?? '-'} / {values.data.studies.academic.averageGrade}
              </div>
            }
            { (values.data.studies?.academic?.city || values.data.studies?.academic?.county) &&
              <div className="overview-item">
                {t(
                  'overview.academic.cityAndCounty')}: {values.data.studies.academic.city} - {values.data.studies.academic.county}
              </div>
            }
          
          </div>
      </>
    }
    {(values.data?.studies?.job) &&
      <div className="overview-section">
        <div className='row'>
          <div className='col-11'>
            <h3>{t('overview.job.title')}</h3>
          </div>
          <div className='col-1 d-flex justify-content-end'>
            <Edit onClick={() => { setStep(1); }}></Edit>
          </div>
        </div>
        {values.data.studies.job.experience &&
          values.data.studies.job.experience.map((el, id) => {
            return <div key={id} className="mb-4">
                <div className="overview-item">{t(
                  'overview.job.experience.function')}: {el.function}</div>
                {el.start && el.end &&
                  <div className="overview-item">{t(
                    'overview.job.experience.time')}: {dateToString(
                    el.start)} - {dateToString(el.end)}</div>
                }
                <div className="overview-item">{t(
                  'overview.job.experience.organization')}: {el.organization}</div>
                
              </div>
          })
        }
        {values.data.studies.job.furtherEducation &&
          <div className="overview-item">{t(
                'overview.job.furtherEducation')}: {values.data.studies.job.furtherEducation}</div>
        }
      </div>
    }
    {/* {(values.data?.studies?.job && (experienceRequired || educationRequired || bonusCreditsType)) &&
      <div className="overview-section">
        <h3>{t('overview.job.title')}</h3>

        {experienceRequired && values.data?.studies?.job?.experience && <>
          <h4>{i++}) {t('overview.job.experience.title')}</h4>
          {values.data.studies.job.experience &&
            values.data.studies.job.experience.map((el, id) => {
              return <div key={id}>
                <div className="overview-item">{t(
                  'overview.job.experience.function')}: {el.function}</div>
                {el.start && el.end &&
                <div className="overview-item">{t(
                  'overview.job.experience.time')}: {dateToString(
                  el.start)} - {dateToString(el.end)}</div>
                }
                <div className="overview-item">{t(
                  'overview.job.experience.organization')}: {el.organization}</div>
              </div>
            })}
        </>}
        {
          educationRequired && values.data?.studies?.job?.education && <>
            <h4>{i++}) {t('overview.job.education.title')}:</h4>
            <div className="overview-item">{values.data.studies.job.education}</div>
          </>
        }
        {
          bonusCreditsType && values.data?.studies?.job?.bonus && <>
            <h4>{i++}) {t('overview.job.bonus.title')}:</h4>
            <div
              className="overview-item">{values.data.studies.job.bonus.subject}</div>
            <div className="overview-item">{t(
              'overview.job.bonus.approvalRequested.label')}: {t(
              'overview.job.bonus.approvalRequested.' +
              values.data.studies.job.bonus.approvalRequested)}</div>
            <div className="overview-item">
              {values.data.studies.job.bonus.experience && <>
                <div>{t('overview.job.bonus.type.' + values.data.studies.job.bonus.type)}</div>
                {values.data.studies.job.bonus.experience.map((el, id) => {
                  return <div key={id}>{dateToString(el.start)} - {dateToString(el.end)}: {el.subject}</div>
                })}
              </>}
            </div>
          </>
        }
      </div>
    } */}
  </div>
}
